import React from "react";
import { Link } from "redux-little-router";
import { truncateText } from "../../../../util";
import "./index.css";

const RecommendedPost = ({ post, onClick, postUrl }) => {
  return (
    <div className="recommended-card">
      <div className="image">
        <Link onClick={onClick} href={postUrl}>
          <img alt="" src={post.coverPhotoUrl} />
        </Link>
      </div>
      <div className="content">
        <Link onClick={onClick} href={postUrl}>
          <h3 className="title" title={post.title}>
            {post.title}
          </h3>
        </Link>
        <span className="description"> {truncateText(post.description, 40)} </span>
        <Link onClick={onClick} className="readmore" href={postUrl}>
          READ MORE
        </Link>
      </div>
    </div>
  );
};

export default RecommendedPost;



// WEBPACK FOOTER //
// ./src/components/RecommendedPosts/components/RecommendedPost/index.js